import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import useGlobalContext from '../../hook/useGlobalContext';
import Sidebar from './Sidebar';
import LanguageSelector from '../../contexts/LanguageSelector';
import { useLanguage } from "../../contexts/LanguageContext";

const translationKeys = {
  T1: "Send us samples for testing",
  T2: "Privacy Policy",
  T3: "HOME",
  T4: "ABOUT US",
  T5: "PRODUCTS",
  T6: "ADMINISTRATION SECTION",
  T7: "CONTACT",
  T8: "MY SPACE",
  T9: "Login",
  T10: "Logout",
  T11: "Beyond Sorting. ",
  T12: "Delivering Material Intelligence.",
  T13: "Welcome,",
  T14: "info@eaglevizion.com",
  T15: "+1 833 273-2453",
};

const Header = () => {
  const { setShowSidebar } = useGlobalContext();

  const [, setWindowWidth] = useState(window.innerWidth);
  const headerRef = useRef(null);

  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState(translationKeys);

  useEffect(() => {
    const translateAll = async () => {
      const keys = Object.keys(translationKeys);
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        const translated = await translateContent(translationKeys[key]);
        return { key, translated };
      });
      const results = await Promise.all(translationPromises);
      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, translateContent]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      

      <div ref={headerRef}>
        {/* Desktop Header */}
        <div className="header-area header-sticky header-sticky--default header-area__desktop">
          <div className="header-top-bar">
            <div className="container">
              <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'stretch', justifyContent: 'space-between', height: '50px', gap: 12 }}>
                {/* Left: email + phone */}
                <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'stretch', gap: 20, flexShrink: 0, height: '100%' }}>
                  <a
                    href="mailto:info@eaglevizion.com"
                    className="pnav"
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                      padding: 0,
                      margin: 0,
                      lineHeight: 1,
                      boxSizing: 'border-box'
                    }}
                  >
                    {translations.T14}
                  </a>
                  <a
                    href="tel:+18332732453"
                    className="pnav"
                    style={{
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                      padding: 0,
                      margin: 0,
                      lineHeight: 1,
                      boxSizing: 'border-box'
                    }}
                  >
                    {translations.T15}
                  </a>
                </div>
                {/* Right: CTA + Privacy Policy */}
                <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'stretch', gap: 12, flexShrink: 0, height: '100%' }}>
                  <a 
                    href={`${process.env.PUBLIC_URL}/contact`} 
                    className="POLITIQUE"
                    style={{
                      whiteSpace: 'nowrap',
                      height: '100%',
                      padding: '0 20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: 0,
                      lineHeight: 1,
                      boxSizing: 'border-box'
                    }}
                  >
                    {translations.T1}
                  </a>
                  <a 
                    href={`${process.env.PUBLIC_URL}/Politique_de_confidentialité`} 
                    className="ht-btn ht-btn--default"
                    style={{
                      whiteSpace: 'nowrap',
                      height: '100%',
                      padding: '0 20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      lineHeight: 1,
                      margin: 0,
                      boxSizing: 'border-box',
                      textTransform: 'none'
                    }}
                  >
                    {translations.T2}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="header-info-area" style={{ padding: '15px 0' }}>
            <div className="header-main-container">
              <div className="header-main-flex">
                {/* Logo */}
                <div className="header-logo" style={{ padding: '10px 0' }}>
                  <Link to="/">
                    <img 
                      src={process.env.PUBLIC_URL + '/assets/img/logo/EVLogo.png'} 
                      alt="Logo" 
                      style={{ height: '50px', width: 'auto' }}
                    />
                  </Link>
                </div>


                {/* Navigation */}
                <nav className="header-nav">
                  <ul className="nav-menu" style={{ fontSize: '17px', fontWeight: '500' }}>
                    <li><Link to="/">{translations.T3}</Link></li>
                    <li><Link to="/about">{translations.T4}</Link></li>
                    <li><Link to="/products">{translations.T5}</Link></li>
                    <li><Link to="/contact">{translations.T7}</Link></li>
                  </ul>
                </nav>
                {/* User Actions */}
                <div className="header-user">
                  <LanguageSelector />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Header */}
        <div className="header-area header-area__mobile">
          <div className="mobile-header-bar">
            <div className="logo">
              <Link to="/">
                <img src={process.env.PUBLIC_URL + '/assets/img/logo/EVLogo.png'} alt="Logo" />
              </Link>
            </div>
            <div className="mobile-actions">
              <LanguageSelector />
              <button
                type="button"
                className="mobile-navigation-icon"
                id="mobile-menu-trigger"
                aria-label="Open menu"
                aria-controls="sidebar"
                onClick={() => setShowSidebar(true)}
              >
                <span>
                  <span />
                  <span />
                  <span />
                </span>
                <span className="sr-only" style={{
                  position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0,
                }}>
                  Open navigation
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Sidebar />
    </>
  );
};

export default Header;